<template>
    <div class="modal" tabindex="-1" :class="{'show': true}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-close" @click="this.$store.commit(closeMutation, false)">
                    <img src="../assets/img/close.svg">
                </div>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Modal',
        components: {},
        props: {
            closeMutation: String,
        },
        mounted() {
            document.body.classList.add('modal-open')
        },
        unmounted() {
            if (document.querySelectorAll('.modal.show').length === 0){
                document.body.classList.remove('modal-open')
            }
        }
    }
</script>
